export const codeSnippet = {
	code1: `const headerStyle = {
  color: 'blue',
  fontSize: '24px',
  padding: '10px',
};

export default function App() {
  return <h1 style={headerStyle}>Hello, React!</h1>;
}`,
	code2: `//App.css:
.header {
  color: green;
  font-size: 24px;
  padding: 10px;
}`,
	code3: `//App.js
import './App.css';

export default function App() {
  return <h1 className="header">Hello, React!</h1>;
}`,
	code4: ` //App.module.css
.header {
  color: red;
  font-size: 24px;
  padding: 10px;
}	`,
	code5: `// App.js:
import styles from './App.module.css';

export default function App() {
  return <h1 className={styles.header}>Hello, React!</h1>;
}`,
	code6: `// App.scss:
$primary-color: #3498db;

.header {
  color: $primary-color;
  font-size: 24px;
  padding: 10px;
}`,
	code7: `//App.js:
import './App.scss';

export default function App() {
  return <h1 className="header">Hello, React!</h1>;
}`,
	code8: `import styled from 'styled-components';

const Header = styled.h1'
	color: purple;
	font-size: 24px;
	padding: 10px;
';

export default function App() {
	return <Header>Hello, React!</Header>;
}`,
}

